import { useMemo } from 'react';

const DEFAULT_TOOLBAR = [
  [{ header: [1, 2, false] }],
  [{ align: [] }],
  ['bold', 'italic'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['link'],
  ['clean'],
];

export const useQuillToolbar = (toolbarConfig) => {
  return useMemo(() => {
    if (!toolbarConfig || toolbarConfig.length === 0) {
      return {
        modules: { toolbar: DEFAULT_TOOLBAR },
        formats: [
          'header',
          'bold',
          'italic',
          'align',
          'list',
          'bullet',
          'link',
          'clean',
        ],
      };
    }

    const rows = [[]];

    const pushToLastRow = (item) => {
      if (!rows[rows.length - 1]) rows.push([]);
      rows[rows.length - 1].push(item);
    };

    toolbarConfig.forEach((token) => {
      if (token === '|') {
        rows.push([]);
        return;
      }

      switch (token) {
        case 'heading':
          pushToLastRow({ header: [false, 1, 2] });
          break;
        case 'alignment':
          pushToLastRow({ align: [] });
          break;
        default:
          pushToLastRow(token);
          break;
      }
    });

    const toolbar = rows.filter((r) => r.length > 0);

    const formats = [
      'header',
      'bold',
      'italic',
      'underline',
      'strike',
      'align',
      'list',
      'bullet',
      'link',
      'clean',
    ];

    return {
      modules: { toolbar },
      formats,
    };
  }, [toolbarConfig]);
};
